export const FIREBASE_CONFIG = {
  apiKey: 'AIzaSyDj0ZCoDo0IkNgW2klejn0xcajEk5o_xiQ',
  authDomain: 'zelajet-sales.firebaseapp.com',
  projectId: 'zelajet-sales',
  storageBucket: 'zelajet-sales.firebasestorage.app',
  messagingSenderId: '834035280086',
  appId: '1:834035280086:web:11054401c747738f1a0177',
  measurementId: 'G-4G7RPJFLB1',
}
